"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactQuery = require("react-query");
var _core = require("@folio/stripes/core");
var _useInvalidateRefdata = _interopRequireDefault(require("./useInvalidateRefdata"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useMutateRefdataValue = _ref => {
  let {
    afterQueryCalls,
    catchQueryCalls,
    endpoint,
    id,
    queryParams,
    returnQueryObject = {
      put: false,
      delete: false
    }
  } = _ref;
  const returnObj = {};
  const ky = (0, _core.useOkapiKy)();
  const invalidateRefdata = (0, _useInvalidateRefdata.default)();
  const deleteQueryObject = (0, _reactQuery.useMutation)(['stripes-kint-components', 'useMutateRefdataValue', 'delete', id], async data => ky.put(`${endpoint}/${id}`, {
    json: {
      id,
      values: [{
        id: data,
        _delete: true
      }]
    }
  }).json().then(afterQueryCalls?.delete).then(() => invalidateRefdata()).catch(catchQueryCalls?.delete), queryParams?.delete);
  const putQueryObject = (0, _reactQuery.useMutation)(['stripes-kint-components', 'editableRefdataList', 'editValue', id], async data => ky.put(`${endpoint}/${id}`, {
    json: {
      id,
      values: [data]
    }
  }).json().then(afterQueryCalls?.put).then(() => invalidateRefdata()).catch(catchQueryCalls?.put), queryParams?.put);
  if (returnQueryObject?.delete) {
    returnObj.delete = deleteQueryObject;
  } else {
    returnObj.delete = deleteQueryObject.mutateAsync;
  }
  if (returnQueryObject?.put) {
    returnObj.put = putQueryObject;
  } else {
    returnObj.put = putQueryObject.mutateAsync;
  }
  return returnObj;
};
var _default = exports.default = useMutateRefdataValue;